// Copyright (c) 2020 Comsearch, Inc., All rights reserved

export const SET_PROJECTS_DATA = 'SET_PROJECTS_DATA'
export const SET_SITES_DATA = 'SET_SITES_DATA'
export const SET_PANORAMA_DATA = 'SET_PANORAMA_DATA'
export const SET_MODEL_DATA = 'SET_MODEL_DATA'
export const SET_VIDEO_DATA = 'SET_VIDEO_DATA'
export const SET_DESIGN_OVERLAY_DATA = 'SET_DESIGN_OVERLAY_DATA'
